import { render, staticRenderFns } from "./ReturnedValueMappingsTable.vue?vue&type=template&id=6a867c47&scoped=true"
import script from "./ReturnedValueMappingsTable.vue?vue&type=script&lang=js"
export * from "./ReturnedValueMappingsTable.vue?vue&type=script&lang=js"
import style0 from "./ReturnedValueMappingsTable.vue?vue&type=style&index=0&id=6a867c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a867c47",
  null
  
)

export default component.exports